import { OptionDef } from '~shared/ui/OptionsGroup'

export enum RoadmapDisplayProperties {
  TITLE = 'Name',
  STATUS = 'Status',
  PRIORITY = 'Priority',
  SCORE = 'Score',
  RELEASE = 'Release',
  ROADMAP = 'Roadmap',
  ASSIGNEE = 'Assignee',
  TAGS = 'Tags',
  REVENUE_IMPACT = 'Revenue impact',
  START_DATE = 'Start date',
  END_DATE = 'End date',
  VALUE = 'Value',
  EFFORT = 'Effort',
  CONNECTIONS = 'Connections',
  ACCOUNTS = 'Accounts',
}

export const staticDisplayProperties: OptionDef[] = [
  { value: RoadmapDisplayProperties.TITLE, label: 'Title', alwaysVisible: true },
  { value: RoadmapDisplayProperties.STATUS, label: 'Status', visibleByDefault: true },
  { value: RoadmapDisplayProperties.PRIORITY, label: 'Priority', visibleByDefault: true },
  { value: RoadmapDisplayProperties.VALUE, label: 'Value' },
  { value: RoadmapDisplayProperties.EFFORT, label: 'Effort' },
  { value: RoadmapDisplayProperties.SCORE, label: 'Score', visibleByDefault: false },
  { value: RoadmapDisplayProperties.REVENUE_IMPACT, label: 'Revenue impact', visibleByDefault: true },
  { value: RoadmapDisplayProperties.RELEASE, label: 'Release', visibleByDefault: true },
  { value: RoadmapDisplayProperties.ROADMAP, label: 'Roadmap' },
  { value: RoadmapDisplayProperties.ASSIGNEE, label: 'Assignee' },
  { value: RoadmapDisplayProperties.TAGS, label: 'Tags' },
  { value: RoadmapDisplayProperties.START_DATE, label: 'Start date' },
  { value: RoadmapDisplayProperties.END_DATE, label: 'End date' },
  { value: RoadmapDisplayProperties.VALUE, label: 'Value' },
  { value: RoadmapDisplayProperties.ASSIGNEE, label: 'Effort' },
  { value: RoadmapDisplayProperties.ACCOUNTS, label: 'Accounts', visibleByDefault: false },
  { value: RoadmapDisplayProperties.CONNECTIONS, label: 'Connections', visibleByDefault: true },
]
